<template>
  <div class="house-selector">
    <div>Select house:</div>
    <div class="buttons">
      <button
        type="button"
        class="house-button gryffindor"
        v-bind:class="{ selected: selection === 'gryffindor', simple: simple }"
        v-on:click="updateSelection('gryffindor')"
      />
      <button
        type="button"
        class="house-button hufflepuff"
        v-bind:class="{ selected: selection === 'hufflepuff', simple: simple }"
        v-on:click="updateSelection('hufflepuff')"
      />
      <button
        type="button"
        class="house-button ravenclaw"
        v-bind:class="{ selected: selection === 'ravenclaw', simple: simple }"
        v-on:click="updateSelection('ravenclaw')"
      />
      <button
        type="button"
        class="house-button slytherin"
        v-bind:class="{ selected: selection === 'slytherin', simple: simple }"
        v-on:click="updateSelection('slytherin')"
      />
      <button
        type="button"
        class="house-button random"
        v-bind:class="{ selected: selection === 'random', simple: simple }"
        v-on:click="updateSelection('random')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "house-selector",
  props: ["simple"],
  data: function () {
    return {
      selection: "",
    };
  },
  methods: {
    updateSelection: function (house) {
      this.selection = house;
      this.$emit("input", this.selection);
    },
  },
};
</script>

<style lang="scss" scoped>
.house-selector {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  .buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;

    .house-button {
      width: 4.75em;
      height: 4.75em;
      border: none;
      padding: 0;
      background-size: contain;
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: inherit;
      outline: none !important;

      &.simple {
        &.selected {
          border: 2px solid red;
        }
      }

      &:not(.simple) {
        transition: all 0.25s ease-in-out;

        &.selected {
          transform: scale(1.3);
        }
      }

      &.gryffindor {
        background-image: url("../assets/Badges/ui-gryffindor-arm.png");
      }

      &.hufflepuff {
        background-image: url("../assets/Badges/ui-hufflepuff-arm.png");
      }

      &.ravenclaw {
        background-image: url("../assets/Badges/ui-ravenclaw-arm.png");
      }

      &.slytherin {
        background-image: url("../assets/Badges/ui-slytherin-arm.png");
      }

      &.random {
        background-image: url("../assets/Badges/ui-not-yet-sorted-arm.png");
      }
    }
  }
}
</style>